import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import ActionButton from '../Button';

const DeleteEditAction = ({ setModal, setDeleteDrugData }) => {
  return (
    <div className="drugAction">
      <div className="desktop-only">
        <ul className="d-flex">
          <li>
            <ActionButton
              img="icon-delete.svg"
              alt=""
              onClick={() => {
                setDeleteDrugData();
                setModal(true);
              }}
              tabIndex="0"
              className="themeFocus"
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

DeleteEditAction.propTypes = {
  setModal: PropTypes.func,
  setIsOpened: PropTypes.func
};

DeleteEditAction.defaultProps = {
  setModal: () => {},
  setIsOpened: () => {}
};
export default DeleteEditAction;
